import styled from 'styled-components';

import { ContentBanner as ContentBannerComponent } from '@xingternal/banner';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL, spaceS, spaceXL, spaceXXL, xdlColorTextSecondary } from '@xingternal/tokens';
import { Headline as HeadlineComponent, Meta as MetaComponent } from '@xingternal/typography';

export const ContentBanner = styled(ContentBannerComponent)`
  flex-direction: column;
  gap: ${spaceXL};
  margin-bottom: ${spaceXXL};
  margin-top: ${spaceL};
  padding: 40px ${spaceXXL} 48px;
  text-align: center;

  @media ${mediaConfined} {
    margin-top: ${spaceXXL};
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;

export const Headline = styled(HeadlineComponent)`
  color: ${xdlColorTextSecondary};
`;

export const Meta = styled(MetaComponent)`
  margin-bottom: ${spaceXXL};
`;
